import httpApi from "@utils/httpApi";
import { AxiosResponse } from "axios";
import {
  ICuratorBillingInformation,
  UpsertBillingInformationPayload,
} from "@src/types/billingInformation";

/**
 * Fetch the authenticated curator's billing profile.
 * Returns null in the data object if none exists yet.
 */
export const getMeBillingInfo = async (): Promise<
  AxiosResponse<{ data: ICuratorBillingInformation | null }>
> => {
  return httpApi.get(`/api/curator-billing-information/me`);
};

/**
 * Create or update the authenticated curator's billing profile.
 */
export const upsertMeBillingInfo = async (
  payload: UpsertBillingInformationPayload
): Promise<AxiosResponse<{ data: ICuratorBillingInformation }>> => {
  const body = {
    data: payload,
  };
  return httpApi.put(`/api/curator-billing-information/me`, body);
};
